import factory from "./factory";
const EndPoint = factory("", "");

const routes = [
  EndPoint("ChangeCampaign", "change-campaign"),
  EndPoint("InvitationRequest", "invitation-request"),
  EndPoint("Assessments", "assessments"),
  EndPoint("LeadAssessments", "lead-assessments")
];

export default routes;
